import React, { InputHTMLAttributes } from 'react';
import DynamicFaIcon from '../DynamicFaIcon';

interface InputSearchGrayProps extends InputHTMLAttributes<HTMLInputElement> {
    icon: string,
    onClick?: () => void
}

const InputSearchGray = (props: InputSearchGrayProps) => {
    const { icon, onClick, ...nativeProps } = props;
    return (
        <>
            <div className="input-icon bg-gray-100 w-full">
                <input type="text" className="input-block bg-gray-100 text-gray-500 p-3" {...nativeProps} />
                <i className='text-gray-800 cursor-pointer' onClick={onClick} >
                    <DynamicFaIcon name={icon} />
                </i>
            </div>
        </>
    );
};

export default InputSearchGray;